export default {
    /**
     * данные компонента
     * @property {array} treviewKeys - порядок ключей для дерева
     */
    data: () => ({
        treviewKeys: []
    }),
    methods: {
        /**
         * рекурсивно добавить подданные
         * @param {object} data - данные
         * @param {object} subdata - порция данных, которые нужно добавить
         * @param {object} condition - элементы иерархии дерева
         * @param {number} depth - глубина рекурсии
         * @param {number} currentDepth - текущая глубина
         * @returns {object}
         */
        treeviewTableAddSubdata(data, subdata, condition, depth, currentDepth) {
            if (currentDepth === depth - 1) {
                let newData = {
                    ...data,
                    subdata: {
                        ...data.subdata,
                        [condition[this.treviewKeys[currentDepth]]]: subdata
                    }
                }
                return newData;
            }
            else {
                let newData = {
                    ...data,
                    subdata: {
                        ...data.subdata,
                        [condition[this.treviewKeys[currentDepth]]]: this.treeviewTableAddSubdata(data.subdata[condition[this.treviewKeys[currentDepth]]], subdata, condition, depth, currentDepth + 1)
                    }
                }
                return newData;
            }
        },
        /**
         * рекурсино получить подданные
         * @param {object} data - данные
         * @param {object} condition - элементы иерархии дерева
         * @param {number} depth - глубина рекурсии
         * @param {number} currentDepth - текущая глубина
         * @returns {object}
         */
        treeviewTableGetSubdata(data, condition, depth, currentDepth) {
            if (currentDepth === depth - 1) {
                return data;
            }
            else {
                return this.treeviewTableGetSubdata(data.subdata[condition[this.treviewKeys[currentDepth]]], condition, depth, currentDepth + 1);
            }
        },
        /**
         * рекурсивно установить условие показа прелоадера на строке
         * @param {object} data - данные
         * @param {string} rowKey - ключ строки
         * @param {object} condition - элементы иерархии дерева
         * @param {number} depth - глубина рекурсии
         * @param {number} currentDepth - текущая глубина
         * @returns {object}
         */
        treeviewTableSetRowPreloader(data, rowKey, condition, depth, currentDepth) {
            if (currentDepth === depth - 1) {
                let newData = {
                    ...data,
                    rowKeyPreloader: rowKey
                }
                return newData;
            }
            else {
                let newData = {
                    ...data,
                    subdata: {
                        ...data.subdata,
                        [condition[this.treviewKeys[currentDepth]]]: this.treeviewTableSetRowPreloader(data.subdata[condition[this.treviewKeys[currentDepth]]], rowKey, condition, depth, currentDepth + 1)
                    }
                }
                return newData;
            }
        },
        /**
         * рекурсивно добавить ключ строки в список активных строк данных
         * @param {object} data - данные
         * @param {string} rowKey - ключ строки
         * @param {object} condition - элементы иерархии дерева
         * @param {number} depth - глубина рекурсии
         * @param {number} currentDepth - текущая глубина
         * @returns {object}
         */
        treeviewTableAddRowActive(data, rowKey, condition, depth, currentDepth) {
            if (currentDepth === depth - 1) {
                let newData = {
                    ...data,
                    rowsActive: [...data.rowsActive, rowKey]
                }
                return newData;
            }
            else {
                let newData = {
                    ...data,
                    subdata: {
                        ...data.subdata,
                        [condition[this.treviewKeys[currentDepth]]]: this.treeviewTableAddRowActive(data.subdata[condition[this.treviewKeys[currentDepth]]], rowKey, condition, depth, currentDepth + 1)
                    }
                }
                return newData;
            }
        },
        /**
         * рекурсивно очистить список активных строк при сворачивании
         * @param {object} data - данные
         * @param {string} rowKey - ключ строки
         * @param {object} condition - элементы иерархии дерева
         * @param {number} depth - глубина рекурсии
         * @param {number} currentDepth - текущая глубина
         * @returns {object}
         */
        treeviewTableRemoveRowActive(data, rowKey, condition, depth, currentDepth) {
            if (currentDepth === depth - 1) {
                let index = data.rowsActive.findIndex((row) => {
                    return row === rowKey;
                })
                data.rowsActive.splice(index,1); 
                data.subdata[rowKey].rowsActive = [];
                data.subdata[rowKey] = this.treeviewTableRemoveSubdataRowsActive(data.subdata[rowKey]);
                return data;
            }
            else {
                let newData = {
                    ...data,
                    subdata: {
                        ...data.subdata,
                        [condition[this.treviewKeys[currentDepth]]]: this.treeviewTableRemoveRowActive(data.subdata[condition[this.treviewKeys[currentDepth]]], rowKey, condition, depth, currentDepth + 1)
                    }
                }
                return newData;
            }
        },
        /**
         * рекурсивно очистить списки активных строк все детей строки, которую сворачиваем
         * @param {object} data - данные
         * @returns {object}
         */
        treeviewTableRemoveSubdataRowsActive(data) {
            let subdataKeys = Object.keys(data.subdata);
            if(subdataKeys.length === 0) {
                let newData = {
                    ...data,
                    rowsActive: []
                }
                return newData
            }
            else {
                subdataKeys.forEach((key) => {
                    data.subdata[key].rowsActive = [];
                    data.subdata[key] = this.treeviewTableRemoveSubdataRowsActive(data.subdata[key])
                });
                return data;
            }
        }
    }
}